(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  class TssDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.tss-drawer__panel');
      this.toggles = Array.from(document.querySelectorAll('[aria-controls="TssDrawer"]'));
      this.onKeydown = this.onKeydown.bind(this);
      this.lastFocus = null;

      this.toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => (this.isOpen() ? this.close() : this.open(toggle)));
        // Bilder schon beim Antippen oder Hovern vorladen, damit sie beim Einfahren da sind
        ['pointerenter', 'pointerdown', 'focus'].forEach((type) =>
          toggle.addEventListener(type, () => this.mount(), { once: true, passive: true })
        );
      });
      this.querySelectorAll('[data-tss-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.querySelectorAll('[data-tss-sub]').forEach((button) => {
        button.addEventListener('click', () => this.openSub(button));
      });
      this.querySelectorAll('[data-tss-back]').forEach((button) => {
        button.addEventListener('click', () => this.closeSub());
      });
      this.querySelectorAll('.tss-drawer__view--sub').forEach((view) => view.setAttribute('inert', ''));

      this.desktopQuery = window.matchMedia('(min-width: 990px)');
      this.onBreakpoint = (event) => {
        if (event.matches && this.isOpen()) this.close(false);
      };
      this.desktopQuery.addEventListener('change', this.onBreakpoint);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      if (this.desktopQuery) this.desktopQuery.removeEventListener('change', this.onBreakpoint);
      document.body.classList.remove('tss-scroll-lock');
    }

    isOpen() {
      return this.classList.contains('is-open');
    }

    mount() {
      if (this.classList.contains('is-mounted')) return false;
      this.classList.add('is-mounted');
      this.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
      return true;
    }

    open(trigger) {
      this.lastFocus = trigger || document.activeElement;
      // Erstes Öffnen: Drawer aus display:none holen, Stil einmal berechnen lassen, dann die Klasse
      // für die Transition setzen. Sonst springt das Panel ohne Einfahren auf.
      this.mount();
      this.getBoundingClientRect();
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      this.toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('tss-scroll-lock');
      document.addEventListener('keydown', this.onKeydown);
      window.setTimeout(() => {
        const first = this.focusables()[0];
        (first || this.panel).focus({ preventScroll: true });
      }, 50);
    }

    close(restoreFocus = true) {
      this.closeSub(false);
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      this.toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('tss-scroll-lock');
      document.removeEventListener('keydown', this.onKeydown);
      if (restoreFocus && this.lastFocus) this.lastFocus.focus();
    }

    openSub(button) {
      const view = this.querySelector('#' + button.getAttribute('aria-controls'));
      if (!view) return;
      this.activeSubButton = button;
      button.setAttribute('aria-expanded', 'true');
      this.querySelector('.tss-drawer__view--main').setAttribute('inert', '');
      view.removeAttribute('inert');
      view.setAttribute('aria-hidden', 'false');
      view.classList.add('is-active');
      this.panel.classList.add('has-sub');
      window.setTimeout(() => {
        const back = view.querySelector('[data-tss-back]');
        // preventScroll: Das Panel ist overflow:hidden. Ohne die Option scrollt iOS Safari es seitlich,
        // weil die Unteransicht beim Fokus noch rechts außerhalb steht, und die Kacheln landen links draußen.
        if (back) back.focus({ preventScroll: true });
      }, 50);
    }

    closeSub(restoreFocus = true) {
      const view = this.querySelector('.tss-drawer__view--sub.is-active');
      if (!view) return;
      view.classList.remove('is-active');
      view.setAttribute('aria-hidden', 'true');
      view.setAttribute('inert', '');
      this.querySelector('.tss-drawer__view--main').removeAttribute('inert');
      this.panel.classList.remove('has-sub');
      if (this.activeSubButton) {
        this.activeSubButton.setAttribute('aria-expanded', 'false');
        if (restoreFocus) this.activeSubButton.focus({ preventScroll: true });
      }
      this.activeSubButton = null;
    }

    focusables() {
      const selector = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
      return Array.from(this.querySelectorAll(selector)).filter(
        (el) => !el.closest('[inert]') && el.offsetParent !== null
      );
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        if (this.panel.classList.contains('has-sub')) {
          this.closeSub();
        } else {
          this.close();
        }
        return;
      }
      if (event.key !== 'Tab') return;
      const items = this.focusables();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !this.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !this.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('tss-drawer')) customElements.define('tss-drawer', TssDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tss-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tss-fade-slider')) {
    customElements.define(
      'tss-fade-slider',
      class TssFadeSlider extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('.tss-hero__slide'));
          this.dots = Array.from(this.querySelectorAll('.tss-hero__dot'));
          this.index = 0;
          if (this.slides.length < 2) return;
          if (document.readyState === 'complete') {
            this.hydrate();
          } else {
            window.addEventListener('load', () => this.hydrate(), { once: true });
          }
          this.dots.forEach((dot) => {
            dot.addEventListener('click', () => {
              this.show(parseInt(dot.dataset.go, 10));
              this.restart();
            });
          });
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.restart());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.restart());
          this.restart();
        }
        disconnectedCallback() {
          this.stop();
        }
        hydrate(slide) {
          const imgs = slide ? slide.querySelectorAll('img[data-src]') : this.querySelectorAll('img[data-src]');
          imgs.forEach((img) => {
            if (img.dataset.srcset) img.srcset = img.dataset.srcset;
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            img.removeAttribute('data-srcset');
          });
        }
        show(i) {
          const n = this.slides.length;
          this.index = ((i % n) + n) % n;
          this.slides.forEach((s, k) => {
            const on = k === this.index;
            s.classList.toggle('is-active', on);
            if (on) {
              s.removeAttribute('aria-hidden');
              this.hydrate(s);
              const img = s.querySelector('img');
              if (img && img.loading === 'lazy') img.loading = 'eager';
            } else {
              s.setAttribute('aria-hidden', 'true');
            }
          });
          this.dots.forEach((d, k) => d.setAttribute('aria-current', k === this.index ? 'true' : 'false'));
        }
        stop() {
          clearInterval(this.timer);
        }
        restart() {
          this.stop();
          if (this.dataset.autoplay !== 'true') return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const ms = parseInt(this.dataset.interval, 10) || 6000;
          this.timer = setInterval(() => this.show(this.index + 1), ms);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tss-home-prices"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tss-tabs')) {
    customElements.define(
      'tss-tabs',
      class TssTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i, false));
            tab.addEventListener('keydown', (e) => this.onKey(e, i));
          });
        }
        onKey(e, i) {
          const last = this.tabs.length - 1;
          let next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = i === last ? 0 : i + 1;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = i === 0 ? last : i - 1;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = last;
          if (next === null) return;
          e.preventDefault();
          this.select(next, true);
        }
        select(index, focus) {
          this.tabs.forEach((tab, i) => {
            const on = i === index;
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.tabIndex = on ? 0 : -1;
            const panel = document.getElementById(tab.getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          });
          if (focus) this.tabs[index].focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tss-method-prices"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tss-m-tabs')) {
    customElements.define(
      'tss-m-tabs',
      class TssMethodTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i, false));
            tab.addEventListener('keydown', (e) => this.onKey(e, i));
          });
        }
        onKey(e, i) {
          const last = this.tabs.length - 1;
          let next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = i === last ? 0 : i + 1;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = i === 0 ? last : i - 1;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = last;
          if (next === null) return;
          e.preventDefault();
          this.select(next, true);
        }
        select(index, focus) {
          this.tabs.forEach((tab, i) => {
            const on = i === index;
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.tabIndex = on ? 0 : -1;
            const panel = document.getElementById(tab.getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          });
          if (focus) this.tabs[index].focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tss-page-band"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tss-pg-embed')) {
    customElements.define(
      'tss-pg-embed',
      class TssPgEmbed extends HTMLElement {
        connectedCallback() {
          const btn = this.querySelector('button');
          if (btn) btn.addEventListener('click', () => this.load());
        }
        load() {
          const frame = document.createElement('iframe');
          frame.src = this.dataset.src;
          frame.title = this.dataset.title || 'Eingebetteter Inhalt';
          frame.loading = 'lazy';
          frame.allow = 'autoplay; encrypted-media; picture-in-picture';
          frame.referrerPolicy = 'no-referrer-when-downgrade';
          frame.setAttribute('allowfullscreen', '');
          const host = this.parentElement;
          this.remove();
          host.appendChild(frame);
          frame.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tss-page-price-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tss-pg-tabs')) {
    customElements.define(
      'tss-pg-tabs',
      class TssPgTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i, false));
            tab.addEventListener('keydown', (e) => this.onKey(e, i));
          });
        }
        onKey(e, i) {
          const last = this.tabs.length - 1;
          let next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = i === last ? 0 : i + 1;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = i === 0 ? last : i - 1;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = last;
          if (next === null) return;
          e.preventDefault();
          this.select(next, true);
        }
        select(index, focus) {
          this.tabs.forEach((tab, i) => {
            const on = i === index;
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.tabIndex = on ? 0 : -1;
            const panel = document.getElementById(tab.getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          });
          if (focus) this.tabs[index].focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tss-page-split"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tss-pg-embed')) {
    customElements.define(
      'tss-pg-embed',
      class TssPgEmbed extends HTMLElement {
        connectedCallback() {
          const btn = this.querySelector('button');
          if (btn) btn.addEventListener('click', () => this.load());
        }
        load() {
          const frame = document.createElement('iframe');
          frame.src = this.dataset.src;
          frame.title = this.dataset.title || 'Eingebetteter Inhalt';
          frame.loading = 'lazy';
          frame.allow = 'autoplay; encrypted-media; picture-in-picture';
          frame.referrerPolicy = 'no-referrer-when-downgrade';
          frame.setAttribute('allowfullscreen', '');
          const host = this.parentElement;
          this.remove();
          host.appendChild(frame);
          frame.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
